import React from 'react'

/**
 * Universal accessibility pictogram: a circle containing a stick figure
 * (head, outstretched arms, legs). Outlined style using currentColor so
 * it inherits the button's text color and works in both light and dark.
 */
const AccessibilityIcon = ({ size = 22 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="10.25" strokeWidth="1.5" />
    <circle cx="12" cy="7.2" r="1.25" fill="currentColor" strokeWidth="0" />
    <path d="M5.8 10 L12 11.5 L18.2 10" strokeWidth="1.5" />
    <path d="M12 11.5 V14.8 L9.6 19.2" strokeWidth="1.5" />
    <path d="M12 14.8 L14.4 19.2" strokeWidth="1.5" />
  </svg>
)

export default AccessibilityIcon
